import { Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { ReactNode } from "react";

import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface Props<TSchema extends FieldValues> {
  name: Path<TSchema>; // Allow only field names (string) that are listed into the Schema
  label: ReactNode;
  placeholder: string;
  errorMessage?: string;
  control: Control<TSchema>;
  className?: string;
  isVertical?: boolean;
}

export default function FieldTextArea<TSchema extends FieldValues>(
  props: Props<TSchema>,
) {
  const {
    name,
    label,
    placeholder,
    errorMessage,
    control,
    className,
    isVertical,
  } = props;
  return (
    <Form.Item
      validateStatus={errorMessage ? "error" : ""}
      help={errorMessage || null}
      label={label}
      className={className}
      layout={isVertical ? "vertical" : "horizontal"}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <TextArea
            {...field}
            placeholder={placeholder}
            autoSize={{ minRows: 4, maxRows: 4 }}
          />
        )}
      />
    </Form.Item>
  );
}
